import { AlertSnackbarProps } from "features/components/alertSnackbar"
import { enqueueSnackbar } from "notistack"

export const setGlobalMessage = ({ message, severity }: AlertSnackbarProps) => {
  enqueueSnackbar(message, {
    variant: severity,
  })
}
